import { useMutation } from "react-query";
import { createApiWithPath } from "../../client";

export const useTriggerCheckIn = () => {
  return useMutation(async (itemId: string) => {
    const response = await createApiWithPath("people-connection").post(
      `/item/${itemId}/trigger-check-in`,
    );
    return response.data;
  });
};
